import {
  UserGroupIcon,
  CalendarIcon,
  IdentificationIcon,
  ScaleIcon,
  MapIcon,
  HeartIcon,
  CurrencyDollarIcon,
  UsersIcon,
  AcademicCapIcon,
  ClipboardDocumentCheckIcon,
  ChartBarIcon,
  HandThumbUpIcon,
  LightBulbIcon,
} from "@heroicons/react/24/solid";

export const searchSuggestions = [
  "partisanship in North Carolina by county",
  "abortion support in FL congressional districts",
  "New York",
  "state upper houses in TX",
  "Trump support in Los Angeles County, CA",
  "turnout in WY counties",
  "Shelby County",
];

export const tabColorClasses = {
  metrics: {
    main: "style-primary",
    text: "text-style-primary",
    border: "border-style-primary",
    bg: "bg-style-primary",
    ring: "ring-style-primary",
  },
  filters: {
    main: "style-secondary",
    text: "text-style-secondary",
    border: "border-style-secondary",
    bg: "bg-style-secondary",
    ring: "ring-style-secondary",
  },
  places: {
    main: "style-green",
    text: "text-style-green",
    border: "border-style-green",
    bg: "bg-style-green",
    ring: "ring-style-green",
  },
};

export const tabNames = {
  metrics: "What",
  filters: "Who",
  places: "Where",
};

export const tabDescriptions = {
  metrics: "What data do you want to see?",
  filters: "Who do you want to see it for?",
  places: "Where do you want to see it?",
};

export const icons = {
  ethnicity: <UserGroupIcon />,
  age: <CalendarIcon />,
  gender: <IdentificationIcon />,
  early_vote: <CalendarIcon />,
  partisanship: <ScaleIcon />,
  urbanicity: <MapIcon />,
  marital_status: <HeartIcon />,
  income: <CurrencyDollarIcon />,
  presence_of_children: <UsersIcon />,
  education: <AcademicCapIcon />,
  vote_history: <ClipboardDocumentCheckIcon />,
  turnout_scores: <ChartBarIcon />,
  scores: <HandThumbUpIcon />,
  TrueViews: <LightBulbIcon />,
};
